import { useEffect, useState } from 'react'

import {
  Link,
  useLocation,
  useNavigate,
  useRevalidator,
} from '@remix-run/react'
import { useTranslation } from 'react-i18next'

import { defaultLocale } from '#app/utils/i18n.ts'
import { cn, removeTrailingSlash } from '#app/utils/misc.tsx'

// function MenuItem({
//   children,
//   to,
//   newTab,
// }: {
//   children: string
//   to: string
//   newTab: boolean
// }) {
//   const { i18n } = useTranslation()
//   let link = to

//   if (!link.includes('http') && i18n.language !== defaultLocale) {
//     link = `/${i18n.language}${link}`
//   }

//   return (
//     <NavLink
//       to={removeTrailingSlash(link)}
//       prefetch={newTab ? undefined : 'intent'}
//       target={newTab ? '_blank' : undefined}
//       rel={newTab ? 'noopener noreferrer' : undefined}
//       className="underlined inline-block text-xl text-primary lg:text-2xl"
//     >
//       {children}
//     </NavLink>
//   )
// }

// function Menu({ items }: { items: LinkType[] }) {
//   const { t } = useTranslation()

//   return (
//     <SheetContent className="z-50 flex flex-col justify-center px-16 sm:max-w-[300px] md:max-w-[600px] lg:px-24">
//       <ul className="mb-4 space-y-6 border-b border-muted pb-8 lg:space-y-10">
//         {items.map(item => (
//           <li key={item.id}>
//             <MenuItem to={item.url} newTab={item.openInNewTab}>
//               {item.text}
//             </MenuItem>
//           </li>
//         ))}
//       </ul>
//       <a href="https://www.google.com/maps" className="text-sm text-primary">
//         {t('info.address')}
//       </a>
//       <a
//         href={`tel:${t('info.phone')}}`}
//         className="block text-sm text-primary"
//       >
//         {t('info.phone')}
//       </a>
//     </SheetContent>
//   )
// }

export function Navbar({
  hideLogo = false,
  // items,
}: {
  hideLogo?: boolean
  // items: LinkType[]
}) {
  const location = useLocation()
  const navigate = useNavigate()
  const revalidator = useRevalidator()
  const { i18n } = useTranslation()

  const [, setMenuOpen] = useState(false)

  useEffect(() => {
    if (open) {
      setMenuOpen(false)
    }
  }, [location])

  const onLangChange = (lang: string) => {
    if (lang !== i18n.language) {
      i18n.changeLanguage(lang)

      navigate(
        removeTrailingSlash(
          lang === defaultLocale
            ? `/${location.search}`
            : `/${lang}/${location.search}`,
        ),
      )

      // Force refresh of data
      revalidator.revalidate()
    }
  }

  return (
    <nav
      className={cn(
        'fixed left-0 right-0 top-0 z-20 flex justify-between p-6 lg:px-12 lg:pt-12',
        hideLogo ? 'justify-end' : 'justify-between',
      )}
    >
      {hideLogo ? null : (
        <Link to="/" className="block">
          <img
            src="/images/logo.svg"
            alt="Logo of V12"
            className="h-10 w-auto lg:h-12"
          />
        </Link>
      )}
      <div className="flex items-center gap-x-4 p-2 lg:gap-x-8 lg:backdrop-blur-lg">
        <div className="space-x-2">
          <button
            onClick={() => onLangChange('nl')}
            className={cn(
              'border-0 bg-transparent text-lg text-primary lg:text-white',
              {
                'font-bold': i18n.language === 'nl',
              },
            )}
          >
            NL
          </button>
          <span className="text-black lg:text-white">|</span>
          <button
            onClick={() => onLangChange('en')}
            className={cn(
              'border-0 bg-transparent text-lg text-primary lg:text-white',
              {
                'font-bold': i18n.language === 'en',
              },
            )}
          >
            EN
          </button>
        </div>
        {/* <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
          <SheetTrigger className="relative z-20 flex size-10 items-center justify-center text-primary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 lg:text-white">
            <MenuIcon />
          </SheetTrigger>
          <Menu items={items} />
        </Sheet> */}
      </div>
    </nav>
  )
}
